import { useEffect, useState } from 'react'
import to from 'await-catch'
import { getSpecialties } from '../api'
import { mapToOptions } from '../utils/mapToOptions'
import { orderBy } from '../utils/stringsUtils'

const inFlightByKey = {}

export function useSpecialties({ patientObraSocialId, patientPlanId, showLoader, hideLoader, addFlashMessage }) {
	const [specialties, setSpecialties] = useState([])

	useEffect(() => {
		let isMounted = true

		const fetchData = async () => {
			if (!patientObraSocialId || !patientPlanId) {
				setSpecialties([])
				return
			}

			try {
				showLoader && showLoader()

				const request = { idObraSocial: patientObraSocialId, idPlan: patientPlanId }
				const key = `${patientObraSocialId}-${patientPlanId}`

				if (!inFlightByKey[key]) {
					inFlightByKey[key] = to(getSpecialties(request)).finally(() => {
						delete inFlightByKey[key]
					})
				}

				const [err, response] = await inFlightByKey[key]

				if (!isMounted) return

				if (err) throw new Error('Error cargando especialidades')

				const data = response.data || response
				let options = mapToOptions(data, 'idEspecialidad', 'nombre')
				options = orderBy(options, 'label')
				setSpecialties(options)
			} catch {
				if (!isMounted) return
				addFlashMessage && addFlashMessage('Ocurrió un error cargando las especialidades')
			} finally {
				if (!isMounted) return
				hideLoader && hideLoader()
			}
		}

		fetchData()

		return () => {
			isMounted = false
		}
	}, [patientObraSocialId, patientPlanId])

	return { specialties }
}
